import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'get_houseRules_lodgingCancellationPolicy';

const lodgingCancellationPolicyQuery = `
query ${OPERATION_NAME}($arrivalDate: String, $unitUrl: String!) {
    houseRules(unitUrl: $unitUrl, arrivalDate: $arrivalDate) {
        lodgingCancellationPolicy {
            badgeText
            policy
            policyWithDates
            policyPeriods
            policyPeriodsWithDates
        }
    }
}`;

async function lodgingCancellationPolicyGraphQl({arrivalDate, locale, unitUrl}) {
    try {
        return await graphqlQuery(
            OPERATION_NAME,
            lodgingCancellationPolicyQuery,
            {arrivalDate, unitUrl},
            locale
        );
    } catch (e) {
        return null;
    }
}

export default lodgingCancellationPolicyGraphQl;
export {lodgingCancellationPolicyGraphQl, OPERATION_NAME, lodgingCancellationPolicyQuery};
